import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/style.less';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store, history } from './store/store';
import { Route, Switch } from 'react-router-dom';
import { Router } from 'react-router';
import { App } from './components/App';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </Provider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
